import { createStyles, makeStyles } from "@material-ui/core";
import React from "react";
import { ReactComponent as BinIcon } from "../../../assets/images/bin.svg";

interface IOrderCounterProps {
    orderCount: number;
    isDelete: boolean;
}

const useStyles = makeStyles(
    (theme) => createStyles({
        root: {
            background: "#FFFCE6",
            border: "2px solid #FFDD02",
            borderRadius: "0.8rem",
            boxSizing: "border-box",
            width: "4rem",
            height: "4rem",
            display: 'flex',
            alignItems: 'center',
            justifyContent: "center",
            position: 'relative',
            "& p": {
                fontWeight: 600,
                textAlign: "center",
                fontSize: "1.5rem",
            },
            "& span": {
                position: 'absolute',
                bottom: "-1rem",
                right: "-0.85rem"
            }
        }
    }));

export function OrderCounter({
    orderCount,
    isDelete
}: IOrderCounterProps) {
    const { root } = useStyles();
    return <div className={root}>
        <p>
            {orderCount}
        </p>
        {isDelete && <span><BinIcon /></span>}
    </div>

}